import { createEntitySlice } from '@/shared/store/createEntitySlice';
import type { EntityFilters } from '@/shared/types/entity';
import { removalBatchesApi } from '../api';
import type { RemovalBatch, RemovalBatchFormData } from '../types';

const initialState = {
  items: [] as RemovalBatch[],
  loading: false,
  error: null as string | null,
  currentPage: 1,
  perPage: 20,
  total: 0,
  lastPage: 1,
  filters: {
    search: '',
    dateRange: null,
  } as EntityFilters,
};

const { actions, reducer } = createEntitySlice<RemovalBatch, EntityFilters, RemovalBatchFormData>({
  name: 'removalBatches',
  api: removalBatchesApi,
  initialState,
  getListParams: (state) => {
    const { currentPage, perPage } = state.removalBatches;
    return { page: currentPage, perPage };
  },
});

export const {
  fetchItems: fetchRemovalBatches,
  createItem: createRemovalBatch,
  updateItem: updateRemovalBatch,
  deleteItem: deleteRemovalBatch,
  setPage,
  setPerPage,
  setFilters,
} = actions;

export { reducer };
